import script from "./editUser.vue?vue&type=script&setup=true&lang=js"
export * from "./editUser.vue?vue&type=script&setup=true&lang=js"

import "./editUser.vue?vue&type=style&index=0&id=1bfce4f2&lang=css"

const __exports__ = script;

export default __exports__